import { PhoneInput } from '@newo/ui-kit';
import { FC, useEffect, useState } from 'react';
import { Box, Button, Group, Stack, Text } from '@mantine/core';
import { modals } from '@mantine/modals';
import { useTimeout } from '@mantine/hooks';
import AiCallingCard from '../AiCallingCard';

type TalkToAgentProps = {
    handleBack: () => void;
    handleNext: () => void;
};
const TalkToAgent: FC<TalkToAgentProps> = ({ handleBack }) => {
    const [phone, setPhone] = useState('');

    const handleOpenModal = () => {
        modals.open({
            id: 'ai-calling',
            title: '',
            size: 'md',
            centered: true,
            radius: 24,
            children: <AiCallingCard />
        });
    };
    // TODO use socket for modal open
    // eslint-disable-next-line no-magic-numbers
    const { start } = useTimeout(handleOpenModal, 3000);

    useEffect(() => {
        start();
    }, []);
    return (
        <Box w="100%">
            <Stack gap={90}>
                <PhoneInput value={phone} onChange={setPhone} />

                <Box w="100%">
                    <Group justify="space-between">
                        <Button
                            p={0}
                            variant="transparent"
                            onClick={handleBack}
                        >
                            Back
                        </Button>

                        <Group>
                            <Text fz={13}>
                                I agree to be contacted for guided onboarding.
                            </Text>
                            <Button>I agree</Button>
                        </Group>
                    </Group>
                </Box>
            </Stack>
        </Box>
    );
};

export default TalkToAgent;
